import { useUserContext } from '../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { AxiosResponse } from 'axios'
import LimsService from '../Python/APIs/LimsService'
import { tsLimsSample } from '../../Typescript/StuartPy/Lims'
import { GridPaginationModel } from '@mui/x-data-grid-pro'
import { format, isValid } from 'date-fns'
import { tsGetLimsOrdersFilters } from '../../Pages/BioBank/OrdersList/OrdersList'
import { useNavigate, useParams } from 'react-router-dom'
import { useLocalStorage } from 'usehooks-ts'
import { tsGetLimsSampleFilters } from '../../Typescript/UI_Interfaces'
import PyAPI from '../Python/APIs/PyAPI'

export function useGetLimsOrders(apiFilters: tsGetLimsOrdersFilters) {
  const dateFormat = 'yyyy-MM-dd'
  const ownerFilter =
    apiFilters?.owner_id ? `&owner_id=${apiFilters.owner_id}` : ''
  const statusFilter = apiFilters?.status ? `&status=${apiFilters.status}` : ''
  let request = ''
  if (isValid(apiFilters?.start_range) && isValid(apiFilters?.end_range)) {
    request =
      `/lims/issues?start_range=${format(apiFilters.start_range!, dateFormat)}&end_range=${format(apiFilters.end_range!, dateFormat)}` +
      ownerFilter +
      statusFilter
  }

  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<any, AxiosResponse>(
    ['PyAPI', '/lims/issues', request],
    () => PyAPI.get(whoAmI!, request),
    {
      onError: (err) => setError(err),
      enabled: !!whoAmI && !!request && apiFilters.enabled,
    },
  )
}

export function useCreateLimsIssue(fields: object) {
  const { whoAmI } = useUserContext()
  const queryClient = useQueryClient()
  const { setError } = useMessagePopupContext()
  const navigate = useNavigate()
  const [, setCart] = useLocalStorage('BioBankShoppingCart', [])
  return useMutation<any, AxiosResponse>(
    () => LimsService.createLimesIssue(whoAmI!, fields),
    {
      onError: (err) => setError(err),
      onSuccess: async (data) => {
        navigate(`/stuart/bio-bank/order/${data?.LIMSOrderId}`, {
          replace: true,
        })
        setCart([])
        await queryClient.invalidateQueries({
          queryKey: ['LimsService', 'getLimsSamples'],
        })
      },
    },
  )
}

export interface tsGetLimsSamplesResponse {
  data: tsLimsSample[]
  headers: any
}
export function useGetLimsSamples(
  apiFilters: tsGetLimsSampleFilters,
  pagination: GridPaginationModel,
  setTotalRecords: any,
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<tsGetLimsSamplesResponse, AxiosResponse<any, any>>(
    ['LimsService', 'getLimsSamples', apiFilters, pagination],
    () => LimsService.getLimsSamples(whoAmI!, { ...apiFilters, ...pagination }),
    {
      onError: (err) => setError(err),
      enabled: !!whoAmI && apiFilters.enabled,
      onSuccess: (data) => setTotalRecords(data?.headers?.['x-totalrecords']),
    },
  )
}

export function useCancelIssues(setOpen: any, items?: number[]) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  const queryClient = useQueryClient()
  const { order_id } = useParams()
  let cancelSamples = {}
  if (items) {
    cancelSamples = { CancelTissue: items }
  }
  return useMutation<any, AxiosResponse>(
    () =>
      PyAPI.patch(whoAmI, `/lims/issue/${order_id}`, {
        IssueStatus: 'RCN',
        ...cancelSamples,
      }),
    {
      onError: (err) => setError(err),
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['PyAPI', '/lims/issues'],
        })
        await queryClient.invalidateQueries({
          queryKey: ['PyAPI', '/lims/issue'],
        })
        setOpen(undefined)
      },
    },
  )
}
